import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { CallDealerLogsService } from './../../../business-services/call-dealer-logs.service';
import { CallDealerLogsViewModel } from '../../../business-entities/call-dealer-logs-model';
import { PaginationService } from '../../../services/pagination.service';
import { PagerData } from '../../../business-entities/PagerData';
import { Filter } from '../../../business-entities/Filter';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-call-dealer-logs',
  templateUrl: './call-dealer-logs.component.html',
  providers: [DatePipe]
 
})
export class CallDealerLogsComponent implements OnInit {
  searchTerm: string;
  callDealerLogsList: CallDealerLogsViewModel[] = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  dropdownSettings: {};
  dealerList: [];
  selectedDealers: { dealerId: string}[] = [];
  debounceTimer;
  @Input() dealerId;
  @Input() dealerName;
  @Input() selectedDate;
  @Input() applicationId;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  callDealerLogsListPDF: any[];
  dataList :CallDealerLogsViewModel []=[];
  constructor(
    private spinner: NgxSpinnerService,
    private callDealerLogsService: CallDealerLogsService,
    private pagerService: PaginationService,
    private activeModal: NgbActiveModal,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private toaster: ToastrService,
  ) {}

  ngOnInit() {
    this.callDealerLogsService.callDealerLogRequestModal.startRecordNumber = 0;
    this.callDealerLogsService.callDealerLogRequestModal.startRecordNumber = 0;
    this.callDealerLogsList = [];
    this.callDealerLogsService.callDealerLogRequestModal.dealerId = this.dealerId;
    this.callDealerLogsService.callDealerLogRequestModal.selectedDate = this.selectedDate;
    this.callDealerLogsService.callDealerLogRequestModal.applicationId = this.applicationId;
    this.getCallDealerLogsAPI();
  }

  async getCallDealerLogsAPI() {
    this.spinner.show();
    await this.callDealerLogsService
      .getCallDealerLogs(this.callDealerLogsService.callDealerLogRequestModal)
      .then(
        (response) => {
          this.spinner.hide();
          this.callDealerLogsList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            if(this.callDealerLogsList?.length > 0){
              this.callDealerLogsList?.forEach(x => {
                if(x?.callDateTime){
                  x.callDateTime = x.callDateTime ? new Date(x.callDateTime + 'Z') : null;
                }
              })
            }
            this.totalCount =
              this.callDealerLogsList.length > 0
                ? this.callDealerLogsList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.callDealerLogsList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  loadMoreData(event){
    this.debounceFunction(()=>this.onScrollDown(event),200);
  }
  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  
  onScrollDown(_ev) {
    if (this.totalCount > this.callDealerLogsList?.length) {
      this.callDealerLogsService.callDealerLogRequestModal.startRecordNumber =
        this.callDealerLogsList.length;
      this.getCallDealerLogsAPI();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.callDealerLogsService.callDealerLogRequestModal.sortColumn = column;
    this.callDealerLogsService.callDealerLogRequestModal.sortDirection =
      direction;
    this.callDealerLogsService.callDealerLogRequestModal.startRecordNumber = 0;
    this.callDealerLogsList = [];
    this.getCallDealerLogsAPI();
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  onRefresh() {
    this.callDealerLogsList = [];
    this.callDealerLogsService.callDealerLogRequestModal.searchTerm = '';
    this.searchTerm = '';
    this.ngOnInit();
  }
  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCallDetails')}`);

  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 19 },
        1: { cellWidth: 30 },
        2: { cellWidth: 30 },
        3: { cellWidth: 45 },
        4: { cellWidth: 45 },
        5: { cellWidth: 35, }
      }
    });
    doc.save(`${this.translate.instant('lblCallDetails')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.callDealerLogsService.callDealerLogRequestModal.isExport = true
    await this.callDealerLogsService.getCallDealerLogs(this.callDealerLogsService.callDealerLogRequestModal).then((res) => {
      if (!res || res.responseObject === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.callDealerLogsService.callDealerLogRequestModal.isExport = false
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblWoNo')]: item.workOrderNo,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblCallDate')]: this.datePipe.transform(item.callDateTime, 'short')
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblDealerName'),
      this.translate.instant('lblCallDate')
    ];
  }
}
